"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.Safe_box_abi__factory = void 0;
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "previousAdmin",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "newAdmin",
                type: "address",
            },
        ],
        name: "AdminChanged",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "beacon",
                type: "address",
            },
        ],
        name: "BeaconUpgraded",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                indexed: true,
                internalType: "uint8",
                name: "category",
                type: "uint8",
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "partialKeyPartA",
                type: "bytes",
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "partialKeyPartB",
                type: "bytes",
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "proof",
                type: "bytes",
            },
        ],
        name: "DKGComplaintSubmitted",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address[]",
                name: "requester",
                type: "address[]",
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "knotId",
                type: "bytes",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "nonce",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "address",
                name: "stakehouse",
                type: "address",
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "aesPublicKey",
                type: "bytes",
            },
        ],
        name: "DecryptionRequestSubmitted",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "guardian",
                type: "address",
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "recipientAesKey",
                type: "bytes",
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "blsPublicKey",
                type: "bytes",
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "ciphertext",
                type: "bytes",
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "zkProof",
                type: "bytes",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "nonce",
                type: "uint256",
            },
        ],
        name: "DecryptionSubmitted",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "guardianAddress",
                type: "address",
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "aesPublicKey",
                type: "bytes",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "guardianIndexPointer",
                type: "uint256",
            },
        ],
        name: "GuardianAdded",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "guardian",
                type: "address",
            },
        ],
        name: "GuardianRelinquished",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "participant",
                type: "address",
            },
            {
                indexed: true,
                internalType: "uint8",
                name: "category",
                type: "uint8",
            },
        ],
        name: "NoComplaint",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "privateKeyPart",
                type: "bytes",
            },
        ],
        name: "PartialPrivateKeyReveal",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "participant",
                type: "address",
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "sharedPublicKey",
                type: "bytes",
            },
        ],
        name: "PublishDKGResults",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "bytes",
                name: "knotId",
                type: "bytes",
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "ciphertext",
                type: "bytes",
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "aesEncryptorKey",
                type: "bytes",
            },
        ],
        name: "ReEncryptionUpdate",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "participant",
                type: "address",
            },
            {
                indexed: false,
                internalType: "bytes[]",
                name: "referencePoints",
                type: "bytes[]",
            },
            {
                indexed: false,
                internalType: "bytes[]",
                name: "encryptedKeys",
                type: "bytes[]",
            },
        ],
        name: "Round1DataSubmission",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "participant",
                type: "address",
            },
            {
                indexed: false,
                internalType: "bytes[]",
                name: "secondaryReferencePoints",
                type: "bytes[]",
            },
        ],
        name: "Round3DataSubmission",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "implementation",
                type: "address",
            },
        ],
        name: "Upgraded",
        type: "event",
    },
    {
        inputs: [],
        name: "DECRYPTION_APPLICATION_TYPEHASH",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "GUARDIAN_THRESHOLD",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "RE_ENCRYPTION_REQUEST_TYPEHASH",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "_knotId",
                type: "bytes",
            },
            {
                internalType: "address",
                name: "_stakehouse",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "_aesPublicKey",
                type: "bytes",
            },
            {
                components: [
                    {
                        internalType: "uint248",
                        name: "deadline",
                        type: "uint248",
                    },
                    {
                        internalType: "uint8",
                        name: "v",
                        type: "uint8",
                    },
                    {
                        internalType: "bytes32",
                        name: "r",
                        type: "bytes32",
                    },
                    {
                        internalType: "bytes32",
                        name: "s",
                        type: "bytes32",
                    },
                ],
                internalType: "struct ETH2Validation.EIP712Signature[]",
                name: "_signatures",
                type: "tuple[]",
            },
        ],
        name: "aggregateDecryptionApplication",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "_knotId",
                type: "bytes",
            },
            {
                internalType: "address",
                name: "_stakehouse",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "_ciphertext",
                type: "bytes",
            },
            {
                internalType: "bytes",
                name: "_aesEncryptorKey",
                type: "bytes",
            },
            {
                components: [
                    {
                        internalType: "uint248",
                        name: "deadline",
                        type: "uint248",
                    },
                    {
                        internalType: "uint8",
                        name: "v",
                        type: "uint8",
                    },
                    {
                        internalType: "bytes32",
                        name: "r",
                        type: "bytes32",
                    },
                    {
                        internalType: "bytes32",
                        name: "s",
                        type: "bytes32",
                    },
                ],
                internalType: "struct ETH2Validation.EIP712Signature[]",
                name: "_signatures",
                type: "tuple[]",
            },
        ],
        name: "aggregateReEncryption",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "_knotId",
                type: "bytes",
            },
            {
                internalType: "address",
                name: "_stakehouse",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "_aesPublicKey",
                type: "bytes",
            },
        ],
        name: "applyForDecryption",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "commonStringSize",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "decryptionTracker",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "decryptionValidityPeriod",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "dkgComplaints",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "enum IDKGRegistry.LifecycleStatusDKG",
                name: "_s",
                type: "uint8",
            },
        ],
        name: "getUpperTimeBound",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "guardianIndexPointer",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "guardianToDKGLifecycle",
        outputs: [
            {
                internalType: "enum IDKGRegistry.LifecycleStatusDKG",
                name: "",
                type: "uint8",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "_structHash",
                type: "bytes32",
            },
        ],
        name: "hashTypedDataInContext",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract StakeHouseUniverse",
                name: "_universe",
                type: "address",
            },
            {
                internalType: "address[]",
                name: "_initialGuardians",
                type: "address[]",
            },
            {
                internalType: "bytes[]",
                name: "_aesPublicKeys",
                type: "bytes[]",
            },
            {
                internalType: "uint256",
                name: "_decryptionValidityPeriod",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_commonStringSize",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_roundTime",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_startBlock",
                type: "uint256",
            },
        ],
        name: "init",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "initialParticipantCount",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "_knotId",
                type: "bytes",
            },
        ],
        name: "isDecryptionRequestValid",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_guardian",
                type: "address",
            },
        ],
        name: "isGuardianBootstrap",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_guardianAddress",
                type: "address",
            },
        ],
        name: "isGuardianOnTime",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "isGuardianRegistered",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "isGuardianRelinquished",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address[]",
                name: "_portfolioStatement",
                type: "address[]",
            },
            {
                internalType: "bytes",
                name: "_aesPublicKey",
                type: "bytes",
            },
        ],
        name: "joinGuardians",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        name: "knotIdToInternalNonce",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        name: "knotIdToLastRequest",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "_sharedPublicKey",
                type: "bytes",
            },
        ],
        name: "publishDKGResults",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "_knotId",
                type: "bytes",
            },
            {
                internalType: "address",
                name: "_stakehouse",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "_ciphertext",
                type: "bytes",
            },
            {
                internalType: "bytes",
                name: "_aesEncryptorKey",
                type: "bytes",
            },
        ],
        name: "reEncryptSigningKey",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        name: "reEncryptionTracker",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "refuseGuardianDuties",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "roundTime",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "startBlock",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address[]",
                name: "_to",
                type: "address[]",
            },
            {
                internalType: "bytes[]",
                name: "_partialKeyPartA",
                type: "bytes[]",
            },
            {
                internalType: "bytes[]",
                name: "_partialKeyPartB",
                type: "bytes[]",
            },
            {
                internalType: "bytes[]",
                name: "_zkProof",
                type: "bytes[]",
            },
            {
                internalType: "enum IDKGRegistry.ComplaintCategories",
                name: "_complaintType",
                type: "uint8",
            },
        ],
        name: "submitDKGComplaint",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "_recipientAesKey",
                type: "bytes",
            },
            {
                internalType: "bytes",
                name: "_blsPublicKey",
                type: "bytes",
            },
            {
                internalType: "bytes",
                name: "_ciphertext",
                type: "bytes",
            },
            {
                internalType: "bytes",
                name: "_zkProof",
                type: "bytes",
            },
        ],
        name: "submitDecryption",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "enum IDKGRegistry.ComplaintCategories",
                name: "_category",
                type: "uint8",
            },
        ],
        name: "submitNoComplaint",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes[]",
                name: "_referencePoints",
                type: "bytes[]",
            },
            {
                internalType: "bytes[]",
                name: "_encryptedKeys",
                type: "bytes[]",
            },
        ],
        name: "submitRound1Data",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes[]",
                name: "_secondaryReferencePoints",
                type: "bytes[]",
            },
        ],
        name: "submitRound3Data",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "threshold",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "universe",
        outputs: [
            {
                internalType: "contract StakeHouseUniverse",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newImplementation",
                type: "address",
            },
        ],
        name: "upgradeTo",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newImplementation",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes",
            },
        ],
        name: "upgradeToAndCall",
        outputs: [],
        stateMutability: "payable",
        type: "function",
    },
];
class Safe_box_abi__factory {
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.Safe_box_abi__factory = Safe_box_abi__factory;
Safe_box_abi__factory.abi = _abi;
